export enum AdminProgramActivityTemplateTableColumnDataIndex {
  OrdinalNumber = "ordinalNumber",
  Name = "name",
  DaysDelay = "daysDelay",
  RecommendedChannel = "recommendedChannel",
  Options = "options",
}
